import { STORAGE_DESIGN, STORAGE_THEME } from 'constants/storage';
import { hasTemporaryKey } from 'utils/api/auth-utils';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
export function syncThemeWithStorage(theme) {
    if (hasTemporaryKey()) {
        theme && sessionStorage.setItem(STORAGE_THEME, theme);
    } else {
        theme && localStorage.setItem(STORAGE_THEME, theme);
    }
}

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
export function syncDesignWithStorage(design) {
    if (hasTemporaryKey()) {
        design && sessionStorage.setItem(STORAGE_DESIGN, design);
    } else {
        design && localStorage.setItem(STORAGE_DESIGN, design);
    }
}
